export function getApplicationName() {
  return 'Portfolio view';
}
